import { useSelector } from 'react-redux'

import EnterpriseTag from '@/components/EnterpriseTag'
import { selectPlanType } from '@/store/features/user/userSlice'
import { PlanType } from '@/types'

const FeatureEnterpriseTag = () => {
  const planType = useSelector(selectPlanType)

  if (planType === PlanType.Enterprise) {
    return null
  }

  return <EnterpriseTag tooltipText={`Upgrade to ${PlanType.Enterprise} plan to use this feature`} />
}

export default FeatureEnterpriseTag
